
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/magazine/[regionUrlKey]",
      function () {
        return require("private-next-pages/magazine/[regionUrlKey]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/magazine/[regionUrlKey]"])
      });
    }
  